import { Builder } from '@builder.io/react'
import { ProductList } from './ProductList'

Builder.registerComponent(ProductList, {
  name: 'Product List',
  inputs: [
    {
      name: 'title',
      type: 'string',
      defaultValue: 'New Way Van Life Products',
    },
    {
      name: 'description',
      type: 'string',
      defaultValue:
        'With the Superstructure Panel Kit installed, your van options are endless. Check out some of our best sellers.',
    },
    {
      name: 'products',
      type: 'list',
      subFields: [
        {
          name: 'product',
          type: `SwellProductHandle`,
        },
      ],
    },
    {
      name: 'categories',
      type: 'list',
      subFields: [
        {
          name: 'category',
          type: `SwellCategoryHandle`,
        },
      ],
    },
  ],
})
